/* Joyeux Marché — animations complémentaires (23/10, mis à jour le 30/10). Sans dépendance, respecte « animations réduites ». */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function reduced() { return mq.matches || root.classList.contains('jm-reduced'); }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  /* Gerbe d'étoiles et de flocons */
  var GLYPHS = ['✦', '❄', '★', '✧', '❅'], COLORS = ['#B3202A', '#1E4D3B', '#8E6A1E', '#D4A537', '#B3202A'];
  function burst(x, y, n) {
    if (reduced()) return;
    var b = d.createElement('div'); b.className = 'jm-burst'; b.setAttribute('aria-hidden', 'true');
    b.style.left = x + 'px'; b.style.top = y + 'px';
    for (var i = 0; i < (n || 14); i++) {
      var s = d.createElement('span'), a = Math.random() * Math.PI * 2, dist = 40 + Math.random() * 70;
      s.textContent = GLYPHS[i % GLYPHS.length];
      s.style.setProperty('--x', Math.cos(a) * dist + 'px');
      s.style.setProperty('--y', Math.sin(a) * dist - 20 + 'px');
      s.style.setProperty('--r', (Math.random() * 360 - 180) + 'deg');
      s.style.setProperty('--s', (12 + Math.random() * 10) + 'px');
      s.style.setProperty('--c', COLORS[i % COLORS.length]);
      s.style.animationDelay = (Math.random() * 80) + 'ms';
      b.appendChild(s);
    }
    d.body.appendChild(b);
    setTimeout(function () { b.remove(); }, 1300);
  }
  function burstOn(el, n) { if (!el) return; var r = el.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2, n); }
  window.JMBurst = burstOn;

  /* Apparition progressive des grilles de produits et des cartes */
  var SEL = 'product-card, .jm-comp__item, .jm-pack__row, .jm-liste__item, .blog-post-card, .resource-list__item';
  var io = null;
  function revealAll(scope) {
    if (reduced() || !('IntersectionObserver' in window)) return;
    if (!io) io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        var t = x.target; t.classList.add('jm-anim-in'); t.classList.remove('jm-anim-pending'); io.unobserve(t);
        setTimeout(function () { t.classList.remove('jm-anim-in'); t.style.removeProperty('--jm-d'); }, 1400);
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    var els = (scope || d).querySelectorAll(SEL), i = 0;
    els.forEach(function (el) {
      if (el.dataset.jmAnim) return; el.dataset.jmAnim = '1';
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.92 && r.bottom > 0) return; /* déjà visible : on ne cache rien */
      el.style.setProperty('--jm-d', (i++ % 4) * 70 + 'ms');
      el.classList.add('jm-anim-pending'); io.observe(el);
    });
  }

  /* Panier : rebond de l'icône et gerbe au premier ajout de la visite */
  function cartIcon() { return d.querySelector('cart-icon, .header-actions__cart-icon, [href$="/cart"] svg'); }
  function onCartAdded() {
    if (reduced()) return;
    var ic = cartIcon(); if (!ic) return;
    ic.classList.remove('jm-bounce'); void ic.offsetWidth; ic.classList.add('jm-bounce');
    if (!sget('jm_first_add')) { sset('jm_first_add', '1'); burstOn(ic, 12); }
  }
  /* Horizon annonce les ajouts par « shopify:cart:lines-update » (action « add ») avec une promesse :
     on attend qu'elle réussisse pour ne jamais fêter un ajout qui a échoué. */
  d.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.action !== 'add' || !e.promise || !e.promise.then) return;
    e.promise.then(function (r) { if (r && r.detail && r.detail.didError) return; onCartAdded(); }, function () {});
  });

  /* Liste au Père Noël : cœur qui bat et gerbe quand on ajoute */
  d.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-jm-liste-btn]') : null; if (!b) return;
    setTimeout(function () {
      if (b.getAttribute('aria-pressed') !== 'true') return;
      b.classList.remove('jm-heart-pop'); void b.offsetWidth; b.classList.add('jm-heart-pop');
      burstOn(b.querySelector('svg') || b, 10);
    }, 20);
  });

  /* Packs : la remise se débloque à 3 articles */
  d.addEventListener('change', function (e) {
    var f = e.target.closest ? e.target.closest('[data-jm-pack]') : null; if (!f) return;
    setTimeout(function () {
      var deal = f.querySelector('[data-jm-deal]'); if (!deal) return;
      var open = !deal.hidden;
      if (open && !f.dataset.jmUnlocked) { f.dataset.jmUnlocked = '1'; deal.classList.add('jm-unlocked'); burstOn(deal, 16); setTimeout(function () { deal.classList.remove('jm-unlocked'); }, 1300); }
      if (!open) delete f.dataset.jmUnlocked;
    }, 30);
  });

  /* Livraison offerte atteinte : petite fête une fois par visite */
  function checkFreeship() {
    var el = d.querySelector('.jm-freeship.is-done');
    if (!el || sget('jm_freeship_party') || el.offsetParent === null) return;
    sset('jm_freeship_party', '1'); burstOn(el.querySelector('.jm-freeship__bar') || el, 18);
  }

  /* Bandeau : la carte cadeau n'est pas encore en vente, on ne la promet pas */
  function fixAnnounce() {
    d.querySelectorAll('[data-jm-announce]').forEach(function (el) {
      if (/carte cadeau/i.test(el.textContent) && !d.querySelector('a[href*="/pages/carte-cadeau"]')) {
        el.textContent = "Ta commande arrivera sans doute après Noël : pense aux cadeaux du Nouvel An !";
      }
    });
  }

  /* Les petits effets éphémères (étoiles, flocons, gerbes) ne relancent pas la recherche de cartes */
  var FX = /(^|\s)jm-(dust|burst|shoot|star|fx|toast|lutin-toast)/;
  function isFx(n) { return n.nodeType !== 1 || (typeof n.className === 'string' && FX.test(n.className)); }

  function init() {
    revealAll(); checkFreeship(); setTimeout(fixAnnounce, 50);
    var pending = false;
    var mo = new MutationObserver(function (muts) {
      if (pending) return;
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          if (!isFx(nodes[j])) {
            pending = true;
            requestAnimationFrame(function () { pending = false; revealAll(); checkFreeship(); });
            return;
          }
        }
      }
    });
    mo.observe(d.body, { childList: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
